const playVideo = (el: HTMLVideoElement) => {
    el.muted = true;
    el.play();
};

const homepageBannerInit = () => {
    const homepageBanners = document.querySelectorAll<HTMLElement>('.homepage-banner');
    const mql = window.matchMedia('(min-width: 1024px)');

    homepageBanners.forEach(el => {
        const videoEl = document.createElement('video');
        videoEl.classList.add('homepage-banner-video');
        videoEl.setAttribute('muted', '');
        videoEl.setAttribute('autoplay', '');
        videoEl.setAttribute('loop', '');
        videoEl.setAttribute('playsinline', '');

        if (mql.matches) {
            videoEl.setAttribute('poster', el.dataset.videoImgDesktop || '');
            videoEl.setAttribute('src', el.dataset.videoUrlDesktop || '');
        } else {
            videoEl.setAttribute('poster', el.dataset.videoImgMobile || '');
            videoEl.setAttribute('src', el.dataset.videoUrlMobile || '');
        }

        mql.addEventListener('change', e => {
            if (e.matches) {
                videoEl.setAttribute('poster', el.dataset.videoImgDesktop || '');
                videoEl.setAttribute('src', el.dataset.videoUrlDesktop || '');
            } else {
                videoEl.setAttribute('poster', el.dataset.videoImgMobile || '');
                videoEl.setAttribute('src', el.dataset.videoUrlMobile || '');
            }
            playVideo(videoEl);
        });

        el.prepend(videoEl);
        playVideo(videoEl);
    });
};

document.addEventListener('DOMContentLoaded', homepageBannerInit);
